// Reconstructed from the supplied production build; original component names were unavailable.
import { InstagramIcon, LinkedinIcon, React, jsxRuntime } from "../vendor/runtime.js";
function Footer() {
  const [a, n] = React.useState(false);
  React.useEffect(() => {
    const l = new IntersectionObserver(
        ([u]) => {
          u.isIntersecting && n(true);
        },
        {
          threshold: 0.1,
        },
      ),
      c = document.getElementById("footer");
    return (
      c && l.observe(c),
      () => {
        c && l.unobserve(c);
      }
    );
  }, []);
  const i = [
    {
      name: "linkedin",
      Icon: LinkedinIcon,
      url: "https://www.linkedin.com/company/codebruhofficial",
      color: "from-blue-600 to-blue-700",
    },
    {
      name: "instagram",
      Icon: InstagramIcon,
      url: "https://www.instagram.com/codebruh.in/",
      color: "from-pink-600 to-purple-600",
    },
  ];
  return (
    <footer
      id={"footer"}
      className={
        "bg-slate-900 text-white pt-12 sm:pt-16 md:pt-20 pb-6 sm:pb-8 md:pb-10 relative overflow-hidden"
      }
    >
      <div className={"absolute inset-0 opacity-10"}>
        <div
          className={"absolute top-10 left-10 w-20 h-20 bg-indigo-500 rounded-full animate-pulse"}
        />
        <div
          className={"absolute top-32 right-20 w-16 h-16 bg-purple-500 rounded-full animate-bounce"}
          style={{
            animationDelay: "1s",
          }}
        />
        <div
          className={"absolute bottom-20 left-1/4 w-12 h-12 bg-blue-500 rounded-full animate-ping"}
          style={{
            animationDelay: "2s",
          }}
        />
        <div
          className={"absolute bottom-32 right-1/3 w-8 h-8 bg-cyan-500 rounded-full animate-pulse"}
          style={{
            animationDelay: "0.5s",
          }}
        />
      </div>
      <div className={"w-full px-3 sm:px-4 md:px-6 lg:px-8 xl:px-12 2xl:px-16 relative z-10"}>
        <div
          className={
            "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6 sm:gap-8 md:gap-10 lg:gap-12 mb-8 sm:mb-12 md:mb-16"
          }
        >
          <div
            className={`lg:col-span-2 xl:col-span-2 transform transition-all duration-1000 ${a ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}
          >
            <div className={"group"}>
              <h1
                className={
                  "text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-6 bg-gradient-to-r from-indigo-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent animate-gradient-x"
                }
              >
                {"CodeBruh"}
              </h1>
              <p
                className={
                  "text-slate-400 text-sm sm:text-base mb-4 sm:mb-6 max-w-md leading-relaxed group-hover:text-slate-300 transition-colors duration-300"
                }
              >
                {
                  "Final year projects made simple. Buy ready-made academic projects with AI-powered explanations. Built by students, for students."
                }
              </p>
              <div className={"flex space-x-3 sm:space-x-4"}>
                {i.map(({ name: l, Icon: c, url: u, color: m }, f) => (
                  <a
                    key={f}
                    href={u}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    className={`w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-gradient-to-r hover:${m} transition-all duration-300 transform hover:scale-110 hover:rotate-6 hover:shadow-lg hover:shadow-${l === "linkedin" ? "blue" : l === "instagram" ? "pink" : "green"}-500/25 group`}
                    aria-label={l}
                  >
                    {jsxRuntime.jsx(c, {
                      size: 16,
                      className:
                        "sm:w-5 sm:h-5 md:w-6 md:h-6 opacity-70 group-hover:opacity-100 transition-opacity",
                    })}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`sm:col-span-1 lg:col-span-1 xl:col-span-2 transform transition-all duration-1000 delay-200 ${a ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}
          >
            <div className={"group"}>
              <h3
                className={
                  "text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 md:mb-6 text-white group-hover:text-indigo-500 transition-colors duration-300"
                }
              >
                {"Contact Us"}
              </h3>
              <div className={"mb-3 sm:mb-4 md:mb-6"}>
                <a
                  href={"mailto:codebruh@kestroinfotech.com"}
                  className={
                    "text-xs sm:text-sm md:text-base text-cyan-600 hover:text-cyan-400 transition-all duration-300 hover:underline break-all"
                  }
                >
                  {"codebruh@kestroinfotech.com"}
                </a>
              </div>
              <ul className={"space-y-2 sm:space-y-3 md:space-y-4"}>
                <li>
                  <a
                    href={"/contact"}
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-400 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block"
                    }
                  >
                    {"Contact Us"}
                  </a>
                </li>
                <li>
                  <a
                    href={"/mission"}
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-400 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block"
                    }
                  >
                    {"Our Mission"}
                  </a>
                </li>
                <li>
                  <a
                    href={"/blog"}
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-400 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block"
                    }
                  >
                    {"Blog"}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`sm:col-span-1 lg:col-span-1 xl:col-span-1 transform transition-all duration-1000 delay-400 ${a ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}
          >
            <div className={"group"}>
              <h3
                className={
                  "text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 md:mb-6 text-white group-hover:text-purple-400 transition-colors duration-300"
                }
              >
                {"Legal"}
              </h3>
              <ul className={"space-y-2 sm:space-y-3 md:space-y-4"}>
                <li>
                  <a
                    href={"/terms"}
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-400 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block"
                    }
                  >
                    {"Terms of Service"}
                  </a>
                </li>
                <li>
                  <a
                    href={"/copyright"}
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-400 hover:text-white hover:translate-x-2 transition-all duration-300 inline-block"
                    }
                  >
                    {"Copyright Info"}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className={`pt-4 sm:pt-6 md:pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0 transform transition-all duration-1000 delay-600 ${a ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}
        >
          <p className={"text-slate-500 text-xs sm:text-sm text-center sm:text-left"}>
            {"© "}
            {new Date().getFullYear()}
            {" CodeBruh. All rights reserved."}
          </p>
          <div className={"flex items-center space-x-2"}>
            <div className={"w-2 h-2 bg-green-500 rounded-full animate-pulse"} />
            <span className={"text-xs text-slate-400"}>{"Codebruh"}</span>
          </div>
        </div>
      </div>
      <style jsx={true}>{`
        @keyframes gradient-x {
          0%,
          100% {
            background-size: 200% 200%;
            background-position: left center;
          }
          50% {
            background-size: 200% 200%;
            background-position: right center;
          }
        }
        .animate-gradient-x {
          animation: gradient-x 4s ease infinite;
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        @media (max-width: 640px) {
          .grid {
            gap: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .grid {
            gap: 1rem;
          }
        }
      `}</style>
    </footer>
  );
}
export { Footer };
